export default {
  // Shokz 询价管理
  shokzInquiryManagement: {
    title: '询价管理',
    description: '韶音 - 管理客户询价需求和报价流程',

    // 标签页
    tabs: {
      fcl: '整箱询价',
      lcl: '拼箱询价',
      air: '空运询价',
      precarriage: '港前询价',
      oncarriage: '尾程询价'
    },

    // 海运拼箱询价
    lclInquiryManagement: {
      title: '海运拼箱询价',
      add: '新增海运拼箱询价'
    },

    // 空运询价
    airInquiryManagement: {
      title: '空运询价',
      add: '新增空运询价'
    },

    // 工具栏按钮
    toolbar: {
      addInquiry: '新增询价',
      addFclInquiry: '新增整箱询价',
      addLclInquiry: '新增拼箱询价',
      addAirInquiry: '新增空运询价',
      addPrePortInquiry: '新增港前询价',
      addLastMileInquiry: '新增尾程询价',
      batchOperations: '批量操作 ({count})',
      batchExport: '批量导出',
      batchExportExcel: '批量导出Excel',
      batchExportCsv: '批量导出CSV',
      batchDelete: '批量删除',
      quotationSummary: '报价汇总'
    },

    // 表格列标题
    columns: {
      inquiryNo: '询价编号',
      quotationNo: '报价编号',
      viewMoreQuotationNos: '查看其余 {count} 个报价编号',
      source: '询价来源',
      inquirerId: '询价人',
      inquiryStatus: '询价状态',
      inquiryNature: '询价性质',
      businessType: '业务类型',
      targetSuppliers: '目标供应商',
      quotedSuppliers: '已报价',
      prePortQuotationStatus: '头程报价状态',
      trunkLineQuotationStatus: '干线报价状态',
      lastMileQuotationStatus: '尾程报价状态',
      validPeriod: '有效期',
      seaEq: '箱型箱量',
      cargoReadyTime: '货好时间',
      cargoReadyTimeType: '货好时间类型',
      cargoReadyTimeRange: '货好时间区间',
      cargoReadyTimeDate: '货好时间范围',
      cargoReadyTimeStart: '货好时间开始',
      cargoReadyTimeEnd: '货好时间结束',
      totalQuantity: '件数',
      totalWeight: '毛重(KGS)',
      totalCubage: '体积(CBM)',
      status: '询价状态',
      quotationStatus: '报价状态',
      palletNature: '货盘性质',
      carrierId: '船公司',
      airline: '航空公司',
      directTransit: '直达/中转',
      routeId: '航线',
      loadingPortId: '起运港',
      dischargingPortId: '卸货港',
      destinationPortId: '卸货港',
      cargoType: '货物类型',
      weight: '重量(KGS)',
      cubage: '体积(CBM)',
      quantity: '件数',
      density: '密度',
      flightNo: '航班号',
      departureAirportId: '起运机场',
      arrivalAirportId: '目的机场',
      deadLine: '截止时间',
      etd: '期望开航时间',
      eta: '期望到达时间',
      serviceTerm: '服务条款',
      customServiceTerm: '自定义服务条款',
      clientType: '委托单位类型',
      clientTitle: '委托单位名称',
      remarks: '特殊要求',
      createdBy: '创建人',
      dateCreated: '创建时间',
      modifiedBy: '修改人',
      dateModified: '修改时间',
      cargoTransportMode: '货运方式',
      actions: '操作'
    },

    filters: {
      quotationNo: '报价编号',
      quotationNoPlaceholder: '请输入报价编号'
    },

    cargoTransportMode: {
      containerFcl: '集装箱整箱',
      roro: '滚装',
      containerLcl: '集装箱拼箱',
      bulk: '散杂货'
    },

    // 操作按钮
    actions: {
      view: '查看',
      detail: '详情',
      edit: '编辑',
      more: '更多',
      cancelSelection: '取消选择',
      submit: '提交',
      revoke: '撤回',
      delete: '删除',
      copy: '复制',
      confirmSupplier: '确认供应商',
      quotationSummary: '报价汇总',
      sendEmail: '发送询价邮件',
      quoteCompare: '报价汇总'
    },

    // 状态显示
    status: {
      draft: '草稿',
      submitted: '已提交',
      sent: '已发送',
      quoted: '已报价',
      confirmed: '已确认',
      closed: '已关闭',
      pending: '待报价',
      notEnabled: '无需报价',
      rejected: '拒绝报价'
    },

    // 确认对话框
    confirmDialog: {
      submitTitle: '确认提交',
      submitContent: '确定要提交询价 "{inquiryNo}" 吗？',
      submitOk: '确定提交',
      submitCancel: '取消',
      revokeTitle: '确认撤回',
      revokeContent: '确定要将询价 "{inquiryNo}" 撤回为草稿状态吗？',
      revokeOk: '确定撤回',
      revokeCancel: '取消',
      deleteTitle: '确认删除',
      deleteContent: '确定要删除询价 "{inquiryNo}" 吗？',
      batchDeleteTitle: '批量删除确认',
      batchDeleteContent: '确定要删除选中的 {count} 条记录吗？'
    },

    // 复制确认对话框
    copyConfirm: {
      title: '确认复制询价单',
      description: '确认要复制此询价单吗？复制后将创建一个新的草稿询价单。',
      detailTitle: '询价单详情',
      inquiryNo: '询价单编号'
    },

    // 消息提示
    messages: {
      dataLoadFailed: '询价数据加载失败',
      selectRecordsFirst: '请先选择要删除的记录',
      noDataToExport: '没有可导出的数据',
      exportSuccess: '成功导出 {count} 条记录为 {type} 格式',
      exportFailed: '导出 {type} 格式失败，请稍后重试',
      submitSuccess: '询价提交成功',
      submitFailed: '提交失败，请稍后重试',
      revokeSuccess: '询价已撤回为草稿状态',
      revokeFailed: '撤回失败，请稍后重试',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      copySuccess: '复制成功',
      copyFailed: '复制失败，请稍后重试',
      batchDeleteSuccess: '批量删除成功',
      batchDeleteFailed: '批量删除失败',
      alreadyDraft: '询价已是草稿状态，无需撤回',
      onlySubmittedCanRevoke: '只有已提交的询价才能撤回为草稿',
      invalidStatusForAction: '无效的询价状态',
      cannotDeleteRecords: '已提交询价无法删除，请检查选中记录'
    },

    // 未读通知
    notifications: {
      title: '消息提醒',
      prePortQuoted: '头程已报价',
      trunkLineQuoted: '干线已报价',
      lastMileQuoted: '尾程已报价',
      allQuoted: '已完成全部报价'
    },

    // 自定义表格弹窗
    customTableModal: {
      title: '自定义表格字段',
      description: '选择要显示的表格字段',
      resetButton: '重置'
    },

    // 导出
    export: {
      filename: '询价数据'
    },

    // 详情页相关
    detail: {
      assignType: '回填目标'
    },

    filterPlaceholders: {
      enterInquiryNo: '请输入询价编号',
      selectSource: '请选择询价来源',
      selectInquirer: '请选择询价人',
      selectStatus: '请选择询价状态',
      selectCarrier: '请选择船公司',
      selectTrunkLineStatus: '请选择干线报价状态',
      selectPrePortStatus: '请选择头程报价状态',
      selectLastMileStatus: '请选择尾程报价状态',
      selectCargoReadyTimeType: '请选择货好时间类型',
      selectCargoReadyTimeRange: '请选择货好时间区间',
      selectCargoReadyTimeDate: '请选择货好时间范围',
      selectPalletNature: '请选择货盘性质',
      selectDirectTransit: '请选择直达/中转',
      selectRoute: '请选择航线',
      selectPol: '请选择起运港',
      selectPod: '请选择卸货港',
      selectDischargingPort: '请选择卸货港',
      selectCargoType: '请选择货物类型',
      selectServiceTerm: '请选择服务条款',
      enterCustomServiceTerm: '请输入自定义服务条款',
      selectClientType: '请选择委托单位类型',
      enterClientTitle: '请输入委托单位名称',
      enterSeaEq: '请输入箱型箱量',
      enterRemarks: '请输入备注',
      selectDepartureAirport: '请选择起运机场',
      selectArrivalAirport: '请选择目的机场',
      selectFlightNo: '请选择航班号',
      inputFlightNo: '请输入航班号',
      selectDateCreated: '请选择创建时间范围',
      selectDateModified: '请选择修改时间范围',
      selectCreatedBy: '请选择创建人',
      selectModifiedBy: '请选择修改人'
    }
  },

  // Shokz 询价详情页
  shokzInquiryDetail: {
    // 页面标题
    pageTitle: {
      create: '新增询价',
      edit: '询价详情',
      view: '询价详情',
      loading: '加载中...'
    },

    // 表单章节
    sections: {
      basicInfo: '基本信息',
      cargoInfo: '货物信息',
      loadingPoint: '装箱门点',
      deliveryAddress: '尾程送货地址',
      containerInfo: '箱型箱量',
      matchPrice: '匹配运价',
      fclPrice: '干线运价',
      prePortPrice: '港前运价',
      lastMilePrice: '尾程运价',
      supplierQuotation: '供应商报价'
    },

    // 复选框选项
    checkboxes: {
      prePortPrice: '港前价格',
      trunkLinePrice: '干线价格',
      lastMilePrice: '尾程价格'
    },

    // 附件上传
    attachments: {
      title: '附件上传',
      titleRequired: '附件上传 *',
      tip: '支持上传文档、图片、压缩包等文件，单个文件最大20MB，最多上传20个文件'
    },

    // 操作按钮
    actions: {
      saveDraft: '保存草稿',
      exportRate: '导出运价',
      exportQuotation: '导出报价',
      submit: '直接发布',
      directSubmit: '直接提交',
      cancel: '取消',
      back: '返回',
      aiRecognition: 'AI识别',
      addContainerType: '添加箱型',
      matchPrice: '查询匹配运价',
      reset: '重置',
      quoteCompare: '报价汇总'
    },

    form: {
      titles: {
        createFcl: '新增海运整箱询价',
        editFcl: '编辑海运整箱询价',
        viewFcl: '查看海运整箱询价',
        createLcl: '新增海运拼箱询价',
        editLcl: '编辑海运拼箱询价',
        viewLcl: '查看海运拼箱询价',
        createAir: '新增空运询价',
        editAir: '编辑空运询价',
        viewAir: '查看空运询价',
        createPrePort: '新建询价',
        editPrePort: '编辑询价',
        createLastMile: '新建询价',
        editLastMile: '编辑询价'
      },
      tags: {
        prePort: '港前运价 PrePort',
        lastMile: '尾程运价 LastMile'
      },
      sections: {
        basicInfo: '基础信息',
        cargoGroup: '货物组',
        loadingInfo: '装货地信息',
        arrivalNodeInfo: '起运港信息',
        destinationPortInfo: '卸货港信息',
        loadingPortInfo: '起运港信息',
        destinationInfo: '目的地信息',
        prePortLoadingPoint: '港前装箱门点',
        lastMileDeliveryAddress: '尾程送货地址',
        matchResult: '匹配运价结果'
      },
      labels: {
        inquiryNature: '询价性质',
        inquirer: '询价人',
        transportTerms: '运输条款',
        serviceTerm: '服务条款',
        loadingPort: '起运港',
        destinationPort: '卸货港',
        carrier: '船公司',
        airline: '航空公司',
        transportType: '运输类型',
        transportMode: '运输方式',
        directTransit: '直达/中转',
        transferPort: '中转港',
        cargoReadyTime: '货好时间',
        cargoReadyDate: '货好日期',
        cargoReadyRange: '货好时间区间',
        cargoType: '货物类型',
        cargoName: '品名',
        unNo: 'UN 编号',
        hazardClass: '类别',
        hsCode: 'HSCODE',
        cargoValue: '货值',
        quoteDeadline: '报价截止时间',
        etd: '期望开航时间',
        eta: '期望到达时间',
        quantity: '件数',
        grossWeight: '毛重(KGS)',
        volume: '体积(CBM)',
        density: '密度',
        packageType: '包装类型',
        packageMode: '包装方式',
        palletSize: '托盘尺寸(长x宽x高) CM',
        palletQuantity: '托盘数',
        remarks: '特殊要求',
        paymentType: '付款方式',
        originCountries: '起运国家（多选）',
        originCities: '起运城市（多选）',
        destinationCountries: '目的国家（多选）',
        destinationCities: '目的城市（多选）',
        departureAirportTerminal: '起运机场货站',
        arrivalAirportTerminal: '目的机场货站',
        prePortTransportMode: '港前运输方式',
        prePortArrivalNodeType: '港前到达节点',
        lastMileOriginNodeType: '卸货港类型',
        loadingCity: '装货城市',
        loadingRailwayStation: '装货站',
        arrivalCountry: '起运国',
        arrivalCity: '起运城市',
        arrivalSeaport: '起运港',
        arrivalTerminal: '起运码头',
        arrivalRailwayStation: '起运站',
        arrivalAirport: '起运机场',
        airportTerminal: '机场货站',
        originCountry: '卸货国家',
        originCity: '卸货城市',
        originSeaport: '卸货港',
        originTerminal: '卸货码头',
        originRailwayStation: '卸货站',
        originAirport: '卸货机场',
        destinationCountry: '目的国',
        destinationCity: '目的城市',
        destinationSeaport: '目的港',
        destinationRailwayStation: '目的站',
        prePortAddressType: '港前地址类型',
        lastMileTransportMode: '尾程运输方式',
        warehouse: '仓库',
        legacyAirportPickup: '历史地址信息（机场自提）',
        country: '国家',
        province: '省/州',
        city: '市',
        cityName: '城市',
        district: '区/县',
        street: '街道',
        streetTown: '街道/村镇',
        townStreet: '乡/镇/街道',
        community: '社区',
        postalCode: '邮编',
        detailAddress: '详细地址',
        deliveryType: '配送类型',
        deliveryAddressType: '配送地址类型',
        fbaCode: 'FBA代码',
        warehouseCode: '仓库代码(FBA)',
        ecang: '易仓',
        ecangWarehouse: '易仓仓库',
        destinationAirport: '目的机场',
        departureAirport: '起运机场',
        loadingCountry: '起运国家',
        originCountryOrLocation: '起运国家/地点',
        destinationCountryOrLocation: '目的国家/地点',
        terminalYard: '码头/堆场',
        destinationTerminal: '目的码头',
        loadingTerminal: '起运码头',
        expectedDeliveryTime: '预计送达时间',
        rateNo: '运价号',
        supplier: '供应商',
        validPeriod: '有效期',
        voyage: '航程',
        currentPrice: '当前报价',
        expectedPrice: '期望价格',
        negotiationNote: '磋商说明',
        replyPrice: '回复价格',
        replyNote: '回复说明',
        changeContent: '变更内容'
      },
      columns: {
        feeName: '费用名称',
        billingMethod: '计费方式',
        unitPrice: '单价',
        currency: '币种'
      },
      options: {
        inquiry: '询价',
        realOrder: '实单',
        direct: '直达',
        transit: '中转',
        unspecified: '不指定',
        date: '日期',
        range: '区间',
        generalCargo: '普货',
        magnetic: '带磁',
        battery: '带电',
        magneticBattery: '带磁带电',
        carton: '纸箱',
        woodenCase: '木箱',
        pallet: '托盘',
        wovenBag: '编织袋',
        bulkCargo: '散货',
        dryContainer: '普通干货箱',
        reeferContainer: '冷藏箱',
        openTopContainer: '开顶箱',
        thirdPartyAddress: '第三方地址',
        warehouse: '仓库',
        inlandPoint: '内陆点',
        prepaid: '预付',
        collect: '到付',
        prepaidOrCollect: '预付/到付',
        truck: '卡车',
        trailer: '拖车',
        barge: '驳船',
        rail: '铁路',
        seaport: '海港',
        railwayStation: '铁路站',
        airport: '机场',
        amazonWarehouse: '亚马逊仓库',
        ecang: '易仓',
        airportPickup: '机场自提',
        yes: '是',
        no: '否'
      },
      placeholders: {
        select: '请选择',
        inputServiceTerm: '请输入服务条款',
        selectLoadingPort: '请选择起运港',
        selectDestinationPort: '请选择卸货港',
        selectCarrier: '请选择船公司',
        selectAirline: '请选择航空公司',
        selectTransferPort: '请选择中转港（可多选）',
        selectDestinationTerminalYard: '卸货港码头或堆场',
        selectDepartureAirport: '请选择起运机场',
        selectArrivalAirport: '请选择目的机场',
        searchPort: '搜索港口',
        searchPortName: '输入港口名称搜索',
        optionalCarrier: '可不指定',
        multipleSelect: '支持多选',
        selectDate: '选择日期',
        inputCargoName: '请输入品名',
        inputHsCode: '请输入HS Code',
        customsCode: '海关编码',
        customsCode8: '海关编码，8位',
        declaredValue: '申报价值',
        cargoValue: '货值',
        inputQuantity: '件数',
        inputGrossWeight: '毛重(KGS)',
        inputGrossWeightShort: '毛重',
        inputVolume: '体积',
        inputRemarks: '请输入备注（最多500字）',
        remarkTip: '补充说明，会显示在货代的报价页面中',
        inputPostalCode: '请输入邮编',
        inputOrSelectPostalCode: '请输入或选择邮编',
        inputDetailAddress: '请输入详细地址',
        fillDetailAddress: '请填入详细地址',
        doorFloorPosition: '门牌/楼层/具体位置',
        selectEcang: '请选择易仓',
        selectWarehouse: '请选择仓库',
        fbaExample: '如：LAX9, ONT8',
        fbaCode: '请输入FBA仓库代码，如：LAX9, ONT8'
      },
      buttons: {
        delete: '删除',
        addCargoGroup: '添加货物组',
        matchPrice: '查询匹配运价',
        negotiate: '磋商',
        importPriceLib: '导入库'
      },
      summary: {
        totalQuantity: '总件数',
        totalWeight: '总毛重',
        totalVolume: '总体积',
        density: '密度'
      },
      match: {
        noMatchedPrice: '暂无匹配运价',
        trunkLineRate: '干线运价',
        prePortRate: '港前运价',
        lastMileRate: '尾程运价',
        noTrunkLineRate: '未查询到匹配的干线运价',
        noPrePortRate: '未查询到匹配的港前运价',
        noLastMileRate: '未查询到匹配的尾程运价',
        clickMatchPrice: '请点击"查询匹配运价"按钮获取运价信息',
        day: '天'
      },
      negotiation: {
        title: '磋商记录',
        empty: '暂无磋商记录'
      }
    },

    detail: {
      loading: '加载中...',
      backToList: '返回列表',
      export: '导出',
      inquiryInfo: '询价信息',
      inquiryNoWithValue: '询价编号：{no}',
      sentSuppliersWithCount: '已发送供应商 ({count}家)',
      contact: '联系人',
      quotedAt: '报价时间',
      fields: {
        inquiryNature: '询价性质',
        transportTerms: '运输条款',
        serviceTerm: '服务条款',
        cargoType: '货物类型',
        loadingPort: '起运港',
        loadingPortForLastMile: '装货港',
        dischargingPort: '卸货港',
        destinationPort: '卸货港',
        carrier: '船公司',
        airline: '航空公司',
        directTransit: '运输方式',
        cargoReadyTime: '货好时间',
        quoteDeadline: '报价截止',
        cargoDescription: '品名',
        cargoValue: '货值',
        createdBy: '创建人',
        createdAt: '创建时间',
        remarks: '特殊要求',
        cargoGroupCount: '货物组数',
        quantity: '件数',
        totalTonnage: '总吨位',
        grossWeight: '毛重',
        volume: '体积',
        packingMode: '包装方式',
        departureAirport: '起运机场',
        arrivalAirport: '目的机场',
        chargeableWeight: '计费重',
        loadingAddress: '起运地址',
        terminal: '码头',
        destinationAddress: '目的地址',
        expectedDeliveryDate: '期望送货日期',
        transportMode: '拖运方式'
      },
      units: {
        piece: '件'
      },
      businessTypes: {
        fcl: '海运整箱 FCL',
        lcl: '海运拼箱 LCL',
        air: '空运 Air',
        prePort: '港前运价',
        lastMile: '尾程运价'
      },
      status: {
        draft: '草稿',
        submitted: '已提交',
        completed: '已完成'
      },
      inquiryNature: {
        pricing: '核价',
        formal: '正式询价'
      },
      directTransit: {
        direct: '直达',
        transit: '中转',
        unspecified: '不指定'
      },
      cargoTypes: {
        general: '普货',
        magnetic: '带磁',
        battery: '带电',
        magneticBattery: '带磁带电'
      },
      cargoReadyRanges: {
        oneWeek: '一周内',
        twoWeeks: '二周内',
        oneMonth: '一个月内',
        moreThanOneMonth: '一个月以上',
        unknown: '时间未知',
        threeDays: '三天内'
      },
      packingModes: {
        dry: '普通干货箱',
        reefer: '冷藏箱',
        openTop: '开顶箱'
      },
      supplierStatus: {
        imported: '已入库',
        quoted: '已报价',
        rejected: '已拒绝',
        pendingQuote: '待报价'
      }
    },

    // 基本信息字段
    basicInfo: {
      inquiryNo: '询价编号',
      inquirerId: '询价人',
      inquiryNature: '询价性质',
      businessType: '业务类型',
      deadline: '报价截止时间',
      palletNature: '货盘性质',
      cargoReadyTime: '货好时间',
      palletQuality: '货盘质量',
      serviceTerm: '服务条款',
      client: '委托单位',
      directTransit: '运输方式',
      detailAddress: '详细地址',
      cargoTransportMode: '货运方式',
      onePriceSupported: 'All In 价格',
      onePriceSupportedTip: '开启后，供应商报价默认选中 All In，供应商可取消勾选'
    },

    // 货物信息字段
    cargoInfo: {
      directTransit: '直达/中转',
      route: '航线',
      loadingPort: '起运港',
      destinationPort: '卸货港',
      dischargingPort: '卸货港',
      transitPort1: '中转港(1st)',
      transitPort2: '中转港(2nd)',
      transitPort3: '中转港(3rd)',
      cargoType: '货物类型',
      hazardClass: '危险品等级',
      unNo: 'UN No',
      temperature: '温度',
      ventilation: '通风量',
      quantity: '数量',
      cargoQuantity: '货量',
      weight: '重量',
      weightUnit: '重量单位',
      dimensions: '尺寸',
      dimensionsUnit: '尺寸单位',
      length: '长',
      width: '宽',
      height: '高',
      cargoDescription: '品名（HS Code）',
      containerRequirement: '用箱要求',
      transportTerms: '运输条款',
      cargoValue: '货值',
      cargoValueCurrency: '货值币种',
      carrier: '船公司',
      flightNo: '航班号',
      remarks: '特殊要求'
    },

    // 装箱门点字段
    loadingPoint: {
      selectArea: '选择装箱门点区域',
      postalCode: '邮编',
      stuffingTerminal: '装箱码头/堆场',
      stuffingTerminalPlaceholder: '请选择码头/堆场',
      deliveryTerminal: '交货码头/堆场',
      deliveryTerminalPlaceholder: '请选择码头/堆场',
      country: '国家',
      province: '省份',
      city: '城市',
      district: '区/县',
      street: '街道/村镇',
      community: '社区',
      stuffingSection: '港前装箱门点',
      stuffingCountry: '国家',
      stuffingProvince: '省/州',
      stuffingCity: '市',
      stuffingDistrict: '区/县',
      stuffingStreet: '乡/镇/街道',
      stuffingCommunity: '社区',
      detailAddress: '详细地址',
      assignType: '分配目标'
    },

    // 尾程送货地址字段
    deliveryAddress: {
      addressInfo: '配送地址信息',
      addressType: '配送地址类型',
      postalCodeAndCountry: '邮编和国家',
      country: '请选择国家',
      postalCode: '请输入或选择邮编',
      provinceCity: '省市区',
      province: '省份',
      city: '城市',
      district: '区/县',
      detailAddress: '详细地址',
      amazonWarehouse: '亚马逊仓库选择',
      ecangWarehouse: '易仓仓库选择'
    },

    // 箱型箱量字段
    containerInfo: {
      containerType: '箱型',
      quantity: '数量',
      containerTypeAndQuantity: '箱型箱量：',
      rfTemperatureRequirement: '温度要求',
      rfVentilationRequirement: '通风要求',
      temperatureRange: '请输入温度范围，如：-20 至 30',
      temperatureStart: '起始温度',
      temperatureEnd: '结束温度',
      ventilationDoor: '通风门',
      ventilationOpen: '开',
      ventilationClose: '关',
      ventilationVolume: '风量',
      ventilationVolumeUnit: 'CBM/H',
      ventilationVolumePlaceholder: '请输入风量',
      humidity: '湿度',
      humidityPlaceholder: '请输入湿度',
      humidityUnit: '%RH',
      needPrecooling: '是否预冷',
      needPrecoolingYes: '是',
      needPrecoolingNo: '否',
      temperatureTo: '至',
      cargoQuantity: '件数',
      weight: '重量',
      weightUnit: '重量单位',
      dimensions: '尺寸',
      dimensionsUnit: '尺寸单位',
      length: '长',
      width: '宽',
      height: '高',
      temperatureUnit: '℃'
    },

    roro: {
      title: '车辆信息',
      vehicleType: '车辆类型',
      quantity: '数量',
      brand: '品牌',
      model: '型号',
      dimensions: '尺寸(长×宽×高) M',
      weightKgs: '毛重(KGS)',
      remarks: '备注',
      addVehicle: '添加车辆',
      totalQuantity: '总数量',
      totalWeight: '总毛重',
      totalRlm: '车位米(RLM)',
      vehicleUnit: '辆',
      dimensionsRequired: '请填写车长和车高',
      lengthMax: '车长不能超过20米',
      widthMax: '车宽不能超过5米',
      heightMax: '车高不能超过5米',
      heightWarning: '超高车辆，可能产生附加费',
      weightWarning: '重型车辆，需确认船公司是否接受',
      vehicleTypes: {
        sedan: '轿车',
        suv: 'SUV',
        mpv: 'MPV',
        pickup: '皮卡',
        truck: '卡车',
        bus: '客车',
        machinery: '工程机械',
        other: '其他'
      }
    },

    bulkCargo: {
      title: '散杂货信息',
      cargoKind: '货种',
      tonnage: '吨位(MT)',
      volume: '体积(CBM)',
      stowageFactor: '积载因数',
      packagingType: '包装方式',
      remarks: '备注',
      addCargo: '添加散杂货',
      totalTonnage: '总吨位',
      totalVolume: '总体积',
      averageStowageFactor: '平均积载因数',
      messages: {
        incomplete: '请填写完整的散杂货信息'
      },
      cargoKinds: {
        steel: '钢材',
        coal: '煤炭',
        ore: '矿石',
        grain: '粮食',
        timber: '木材',
        fertilizer: '化肥',
        cement: '水泥',
        sandStone: '沙石',
        vehicle: '车辆',
        other: '其他'
      },
      packagingTypes: {
        bulk: '散装',
        bag: '袋装',
        bundle: '捆装',
        drum: '桶装',
        pallet: '托盘',
        other: '其他'
      }
    },

    // 占位符文本
    placeholders: {
      autoGenerate: '自动生成',
      selectInquiryNature: '请选择询价性质',
      selectBusinessType: '请选择业务类型',
      selectDeadline: '请选择报价截止时间',
      selectPalletNature: '请选择货盘性质',
      selectCargoReadyTimeRange: '请选择货好时间区间',
      selectCargoReadyDate: '请选择货好日期',
      selectOption: '请选择',
      inputServiceTerm: '请输入服务条款',
      selectClientType: '请选择客户类型',
      selectClient: '请选择客户',
      inputClientTitle: '请输入客户抬头',
      selectRoute: '请选择航线',
      selectLoadingPort: '请选择起运港',
      selectDestinationPort: '请选择卸货港',
      selectDischargingPort: '请选择卸货港',
      selectTransitPort1: '请选择第一中转港',
      selectTransitPort2: '请选择第二中转港',
      selectTransitPort3: '请选择第三中转港',
      selectHazardClass: '请选择危险品等级',
      inputUnNo: '请输入UN No',
      inputTemperature: '请输入温度',
      inputVentilation: '请输入通风量',
      enterInputQuantity: '请输入件数',
      inputWeight: '请输入重量',
      inputDimensions: '请输入尺寸',
      inputCargoDescription: '请输入品名或HS Code',
      selectContainerRequirement: '请选择用箱要求',
      selectTransportTerms: '请选择运输条款',
      inputCargoValue: '请输入货值',
      selectCargoValueCurrency: '请选择币种',
      selectCarrier: '请选择船公司',
      inputFlightNo: '请输入航班号',
      inputRemarks: '请输入备注信息',
      province: '省份',
      city: '城市',
      district: '区/县',
      street: '街道/村镇',
      inputDetailAddress: '请填入详细地址',
      selectCountry: '请选择国家',
      inputPostalCode: '请输入或选择邮编',
      inputDeliveryAddress: '请填入详细地址',
      selectAmazonWarehouse: '请选择亚马逊仓库',
      selectEcangWarehouse: '请选择易仓仓库',
      selectContainerType: '请选择箱型',
      inputQuantity: '数量',
      inputLoadingPointAddress: '请填入装箱门点地址',
      inputDeliveryAddressText: '请填入尾程送货地址',
      clickMatchPrice: '请点击"查询匹配运价"按钮获取运价信息',
      noFclMatches: '未查询到匹配的干线运价',
      noPrePortMatches: '未查询到匹配的港前运价',
      noLastMileMatches: '未查询到匹配的尾程运价',
      noFclPrices: '暂无干线运价方案',
      noPrePortPrices: '暂无港前运价方案',
      noLastMilePrices: '暂无尾程运价方案',
      quotePending: '待报价',
      quoteRejected: '拒绝报价',
      noFeeDetail: '暂无费用明细',
      quotationStatus: '报价状态',
      supplier: '供应商',
      allStatus: '全部状态',
      allSuppliers: '全部供应商',
      quoted: '已报价',
      imported: '已导入'
    },

    // 询价性质枚举
    inquiryNature: {
      pricing: '核价',
      formal: '正式询价'
    },

    // 业务类型枚举
    businessType: {
      fcl: '海运整箱',
      lcl: '海运拼箱',
      air: '空运',
      prePort: '港前',
      lastMile: '尾程'
    },

    // 单位和后缀
    units: {
      celsius: '°C',
      kilogram: 'KGS'
    },

    // 消息提示
    messages: {
      originNodeRequired: '起点至少选择国家、城市或港口/机场中的一项',
      destinationNodeRequired: '终点至少选择国家、城市或港口/机场中的一项',
      prePortModeRequired: '请选择港前运输方式和到达节点',
      prePortTruckAddressRequired: '请选择仓库，或填写拖车装货门点的详细地址',
      prePortBargeLoadingRequired: '驳船装货地至少选择装货城市或装货港',
      prePortRailLoadingRequired: '铁路装货地至少选择装货城市或装货站',
      prePortArrivalNodeRequired: '到达节点至少选择国家、城市或当前节点类型对应的港口/车站/机场',
      prePortAddressTypeRequired: '请选择港前地址类型',
      prePortInlandPointRequired: '港前选择内陆点时必须选择起运港',
      prePortThirdPartyAddressRequired: '请填写港前第三方详细地址',
      lastMileModeRequired: '请选择尾程运输方式和地址类型',
      lastMileOriginTypeRequired: '请选择卸货港类型',
      lastMileOriginNodeRequired: '卸货港信息至少选择国家、城市或当前类型对应的港口/车站/机场',
      lastMileTruckDestinationRequired: '拖车目的地请选择仓库或填写第三方详细地址',
      lastMileBargeDestinationRequired: '驳船目的地至少选择目的国、目的城市或目的港',
      lastMileRailDestinationRequired: '铁路目的地至少选择目的国、目的城市或目的站',
      warehouseRequired: '请选择仓库基础数据',
      thirdPartyAddressRequired: '请填写第三方尾程详细地址',
      dangerousCargoRequired: '危险品必须填写 UN 编号、类别、品名和 HSCODE',
      cargoReadyTimeRequired: '请选择完整的货好时间',
      quoteDeadlineRequired: '请选择报价截止时间',
      legacyAddressInfo: '历史地址信息',
      legacyAddressReselect: '编辑提交前请重新选择仓库基础数据',
      deliveryAddressReselect: '提交前请重新选择第三方地址或仓库',
      selectLoadingPortBeforeTerminal: '请先选择起运港',
      noLinkedTerminal: '当前起运港未维护关联码头/堆场',
      saveDraftSuccess: '草稿保存成功',
      updateSuccess: '询价更新成功',
      submitSuccess: '询价发布成功',
      saveFailed: '保存失败',
      submitFailed: '发布失败',
      exportPending: '导出运价功能开发中...',
      addressRecognitionSuccess: '地址识别成功',
      inputAddressFirst: '请输入地址信息',
      confirmSubmit: '确认直接发布？',
      confirm: '确定',
      cancel: '取消',
      loading: '加载中...',
      noData: '无数据',
      detailNotFound: '未查询到询价详情',
      loadDetailFailed: '加载询价详情失败',
      confirmSupplierSuccess: '确认供应商成功',
      confirmSupplierFailed: '确认供应商失败',
      supplierConfirmSuccess: '供应商确认成功',
      supplierConfirmFailed: '确认供应商失败，请重试',
      cancelConfirmSuccess: '取消确认成功',
      cancelConfirmFailed: '取消确认失败',
      supplierCancelConfirmSuccess: '已取消供应商确认',
      supplierCancelConfirmFailed: '取消确认失败，请重试',
      resetFailed: '重置失败，请重试',
      requiredFieldsMissing: '请填写必填项',
      doorPostalCodeRequired: '运输条款为DOOR时，邮编为必填项',
      doorDeliveryAddressRequired: '运输条款为DOOR时，配送详细地址为必填项',
      quoteTextUnavailable: '无法获取报价文本内容',
      orderAlreadyGenerated: '该询价单已生成订单，无法再次订舱',
      quotationMissingForBooking: '报价信息不存在，无法发起订舱',
      bookingFailed: '确认订舱失败',
      copySuccess: '文本已复制到剪贴板',
      copyFailed: '复制失败，请手动复制',
      noAvailablePrices: '未找到可用的运价信息，请查询匹配运价并选择，或等待新的报价。',
      selectQuotedPriceFirst: '请先选择一个已报价的运价',
      loadTemplateFailed: '加载模板失败',
      openTemplateViewReportFailed: '打开模板查看报表失败',
      inquiryAllDisabled: '干线价格、港前价格和尾程价格至少要开启一个',
      trunkOriginPortRequired: '干线起运国、起运地、起运港至少填写一项',
      trunkDestinationPortRequired: '干线目的国、目的地、卸货港至少填写一项',
      trunkOriginAirportRequired: '干线起运国、起运地、起运机场至少填写一项',
      trunkDestinationAirportRequired: '干线目的国、目的地、目的机场至少填写一项',
      routeMatchSuccess: '航线匹配成功',
      routeMatchFailed: '未匹配到航线',
      addressRecognitionFailed: '地址识别失败',
      cargoDescriptionRequired: '运输条款为DOOR时，品名为必填项',
      cargoValueRequired: '服务条款为DDP时或运输条款为DOOR时，货值为必填项',
      cargoValueCurrencyRequired: '服务条款为DDP时或运输条款为DOOR时，货值币种为必填项',
      rfTemperatureStartRequired: '起始温度为必填项',
      rfTemperatureEndRequired: '结束温度为必填项',
      rfVentilationEnableRequired: '通风门为必填项',
      rfVentilationQuantityRequired: '风量为必填项',
      loadingPortSameAsDestination: '起运港和卸货港不能相同',
      destinationPortSameAsLoading: '卸货港和起运港不能相同'
    },

    consignmentLink: {
      title: '关联委托单',
      searchPlaceholder: '请输入委托单号搜索',
      search: '查询',
      link: '关联',
      columns: {
        consignmentNo: '委托单号',
        businessType: '业务类型',
        route: '路线',
        cargo: '货物信息',
        status: '状态',
        actions: '操作'
      },
      messages: {
        selectQuotation: '请选择一条已报价的报价',
        noPermission: '当前页面不允许关联委托单',
        searchFailed: '搜索运输委托单失败',
        linkSuccess: '关联委托单成功',
        linkFailed: '关联委托单失败',
        entrustedDisabled: '已委托的委托单不能关联'
      }
    },

    quotationTable: {
      title: '供应商报价',
      quoteCount: '{quoted}/{total} 家已报价',
      cancelConfirm: '取消确认',
      confirmSupplier: '确认供应商',
      linkConsignment: '关联委托单',
      empty: '暂无供应商报价',
      columns: {
        bpmStatus: '状态',
        supplier: '供应商',
        quotationNo: '报价编号',
        plan: '报价方案',
        transitDays: '航程(天)',
        amount: '费用',
        prePortFee: '港前费用',
        trunkLineFee: '干线费用',
        lastMileFee: '尾程费用',
        totalFee: '综合费用',
        validUntil: '有效期',
        submitDate: '报价时间',
        quotationStatus: '报价状态',
        confirmStatus: '确认状态',
        consultationStatus: '磋商状态',
        importStatus: '导入状态',
        negotiation: '磋商',
        actions: '操作'
      },
      status: {
        imported: '已导入',
        notImported: '未导入',
        quoted: '已报价',
        notQuoted: '未报价',
        confirmed: '已确认',
        unconfirmed: '未确认',
        notConsulted: '未磋商',
        consulting: '磋商中',
        consultationCompleted: '磋商完成',
        pendingConfirm: '待确认'
      },
      plan: {
        prefix: '方案',
        onePrice: 'All In 价格',
        direct: '直达',
        transit: '中转',
        unspecified: '不指定'
      },
      actions: {
        viewDetail: '查看明细',
        negotiate: '磋商',
        continueNegotiate: '继续磋商',
        import: '导入库'
      },
      negotiation: {
        recordsTitle: '磋商记录',
        currentPrice: '当前报价',
        empty: '暂无磋商记录',
        round: '第{index}轮',
        expectedPrice: '期望价格',
        note: '磋商说明',
        status: '状态',
        pending: '待回复',
        replied: '已回复',
        accepted: '已接受',
        rejected: '已拒绝',
        replyPrice: '回复价格',
        replyNote: '回复说明',
        changeContent: '变更内容'
      },
      importConfirm: {
        title: '确认入库',
        content: '确定将「{supplier}」的报价导入运价库吗？'
      },
      messages: {
        importSuccess: '已成功导入运价库',
        importFailed: '导入运价库失败',
        selectQuotation: '请选择一条报价方案'
      }
    },

    combinationModal: {
      previewCount: '将按段写入 {count} 条运价记录',
      previewFailed: '入库预览加载失败，请关闭后重试。',
      segments: { prePort: '港前', trunk: '干线', lastMile: '尾程' },
      warehouses: { prePort: '港前运价库', fcl: '整箱运价库', lcl: '拼箱运价库', air: '空运运价库', lastMile: '尾程运价库' },
      title: '选择组合方式',
      description: '单段默认自由组合，可选择自由或精准组合；确认后直接入库。',
      fixedTip: '多段报价固定使用精准组合，不可切换，确认后直接入库。',
      confirm: '确认导入'
    },

    quotationDetailModal: {
      title: '报价明细 - {supplier}',
      titleWithQuotationNoOnly: '报价明细（{quotationNo}）',
      titleWithQuotationNo: '报价明细 - {supplier}（{quotationNo}）',
      fields: {
        transportMode: '运输方式',
        transitDays: '航程(天)',
        validUntil: '有效期'
      },
      combination: {
        free: '自由组合',
        precise: '精准组合'
      },
      sections: {
        trunkLineFreight: '干线运费',
        trunkLineBaseFee: '干线基础费用',
        trunkLineSurcharge: '干线附加费',
        originPortFee: '起运港费用',
        destinationPortFee: '目的港费用',
        prePortFee: '港前费用',
        prePortBaseFee: '港前基础费用',
        prePortSurcharge: '港前附加费',
        lastMileFee: '尾程费用',
        lastMileBaseFee: '尾程基础费用',
        lastMileSurcharge: '尾程附加费',
        otherFee: '普通附加费',
        potentialFee: '潜在费用',
        totalFee: '综合费用'
      },
      columns: {
        containerType: '箱型',
        feeItem: '费用项',
        feeDetail: '费用明细',
        unitPrice: '单价',
        quantity: '数量',
        unit: '单位',
        billingUnit: '计费单位',
        subtotal: '小计',
        lclOceanFreight: '拼箱海运费',
        airFreight: '空运费',
        truckingFee: '拖车费',
        truckDeliveryFee: '柜车配送费'
      },
      units: {
        container: '箱'
      },
      actions: {
        close: '关闭',
        import: '导入运价库',
        imported: '已导入运价库'
      },
      transportMode: {
        direct: '直达',
        transit: '中转',
        ocean: '海运',
        air: '空运',
        land: '陆运'
      },
      messages: {
        loadFailed: '加载报价明细失败',
        importSuccess: '导入运价库成功',
        importFailed: '导入运价库失败'
      }
    },

    bpm: {
      bannerTitle: '比价确认审批',
      bannerApproved: 'BPM 审批已通过',
      bannerApprovedTail: '可发送中标通知',
      bannerPending: '已发起 BPM 审批',
      bannerPendingTail: '等待审批通过后可发送中标通知',
      bannerRejected: 'BPM 审批已驳回，请调整后重新提交',
      statusLabel: '审批状态',
      awardedSupplier: '中标供应商',
      awardNoticeSent: '中标通知已发送',
      totalCost: '报价合计',
      viewApproval: '查看审批',
      pendingStatusTag: '审批中',
      submit: '提交比价确认审批',
      withdraw: '撤回审批',
      submitTitle: '提交比价确认审批',
      selectQuotation: '选择报价',
      selectQuotationPlaceholder: '请选择要提交审批的报价',
      selectQuotationRequired: '请选择报价',
      selectedSupplier: '拟中标供应商',
      selectedTotal: '拟中标合计',
      relatedInquiryNo: '关联询价单号',
      selectedSupplierLabel: '拟中标供应商',
      selectedSuppliersEmpty: '请先在报价列表中选择一条报价',
      totalCostLabel: '报价合计',
      remark: '备注',
      remarkPlaceholder: '可填写补充说明（选填）',
      workflowLabel: '审批流程',
      workflowName: '比价确认审批流程',
      withdrawTitle: '撤回审批',
      withdrawTip: '撤回后可重新选择报价并提交审批，已发送中标通知后不可撤回。',
      withdrawConfirmTitle: '确认撤回',
      withdrawConfirmContent: '确定要撤回当前审批吗？',
      useBpmInstead: '已开启 BPM 审批，请使用上方「提交比价确认审批」操作',
      bpmConfirmPending: '审批中',
      bpmConfirmWinner: '已确认'
    },

    awardNotice: {
      title: '发送中标通知书邮件',
      send: '发送',
      sendEmail: '发送邮件',
      confirmSend: '确认发送',
      previewBtn: '预览中标通知书',
      downloadBtn: '下载',
      attachmentGenerating: '中标通知书生成中...',
      sendBtn: '发送中标通知',
      previewTitle: '中标通知预览',
      previewEmpty: '暂无预览内容',
      receiverEmail: '收件人邮箱',
      receiverEmails: '收件人',
      receiverEmailPlaceholder: '请输入收件人邮箱',
      receiverEmailsPlaceholder: '输入邮箱地址后回车添加；多个邮箱用逗号或分号分隔',
      receiverEmailRequired: '请填写至少一个收件人邮箱',
      receiverEmailInvalid: '收件人邮箱格式不正确：{email}',
      ccEmails: '抄送',
      ccEmailsPlaceholder: '选填，多个邮箱用逗号或分号分隔',
      ccEmailInvalid: '抄送邮箱格式不正确：{email}',
      subject: '邮件主题',
      subjectPlaceholder: '请输入邮件主题',
      subjectRequired: '请填写邮件主题',
      content: '邮件正文',
      contentRequired: '请填写邮件正文',
      attachment: '附件',
      /** 附件展示名（用户在弹窗中看到的名字） */
      attachmentName: '【中标通知书】.pdf',
      attachmentMissing: '中标通知书附件尚未生成，请稍后再试',
      preview: '预览',
      templateTipTitle: '邮件模板说明',
      templateTip: '邮件内容已根据「{name}」自动生成',
      templateConfigLink: '前往配置',
      quotationRequired: '尚未确认中标供应商，无法发送中标通知',
      sendSuccess: '中标通知邮件已发送',
      sendFailed: '中标通知邮件发送失败',
      templateMissing: '请先在模板配置中维护中标通知书 V3 模板'
    },

    bpmApproval: {
      back: '返回',
      title: '询价 BPM 审批',
      tcFeeTitle: '对账BPM审批',
      tcFeeDetailUnavailable: '请在右侧面板完成审批',
      tcFee: {
        infoTitle: '费用审核信息',
        reconciliationNo: '对账单号',
        consignmentNo: '运输委托单号',
        supplierName: '对账供应商',
        billStatus: '账单状态',
        originalTotal: '原始报价总价',
        currentTotal: '对账总价',
        diffNoteTitle: '供应商差异说明',
        compareTitle: '费用对比',
        noFeeDetail: '暂无费用明细',
        batchApprove: '一键通过微小差异',
        warningTip: '{count} 项费用差异较大，请重点审核',
        minorTip: '{count} 项费用属于微小差异，可快速通过',
        rejectLabel: '驳回',
        colCategory: '费用大类',
        colName: '费用名称',
        colCurrency: '币种',
        colOriginalAmount: '原始金额',
        colCurrentAmount: '对账金额',
        colDiffAmount: '差异额',
        colDiffRate: '差异率',
        batchConfirmTitle: '一键通过微小差异？',
        batchConfirmContent: '当前 {count} 项差异均小于 {currency} {amount} 且差异率小于 {rate}%，确认后将直接通过本次费用审核。',
        batchOk: '通过',
        batchCancel: '取消',
        batchSuccess: '微小差异已通过',
        batchNoAction: '当前节点暂无可执行的通过动作',
        batchFailed: '微小差异批量通过失败',
        batchRemark: '微小差异批量通过：{count} 项费用差异均小于 {currency} {amount} 且差异率小于 {rate}%'
      },
      awardSummary: '中标摘要',
      missingParams: '缺少审批参数，无法加载详情',
      flowInfo: '流程信息',
      flowNo: '流程编号',
      flowName: '流程名称',
      initiator: '发起人',
      applyTime: '发起时间',
      currentApprover: '当前审批人',
      relatedDoc: '关联单据',
      approvalNotes: '审批备注',
      noApprovalNotes: '暂无审批备注',
      progress: '审批进度',
      attachments: '审批附件',
      noAttachments: '暂无附件',
      defaultFlowName: '比价确认审批',
      progressSubmit: '发起比价确认审批',
      progressManager: '部门经理审批',
      progressFinance: '财务总监审批',
      actions: '审批操作',
      noActions: '当前无可执行操作',
      remark: '审批意见',
      remarkPlaceholder: '请输入审批意见（可选）',
      history: '审批历史',
      loadFailed: '加载审批信息失败',
      approve: '同意',
      reject: '驳回',
      return: '退回',
      rollback: '回退',
      cancel: '作废',
      confirmTitle: '确认审批',
      confirmContent: '确定执行「{action}」操作吗？',
      actionSuccess: '审批操作成功',
      actionFailed: '审批操作失败',
      download: '下载',
      downloadFailed: '下载失败'
    },

    consultationModal: {
      title: '发起磋商',
      supplier: '供应商',
      quotationPlan: '报价方案',
      currentPrice: '当前报价',
      expectedPrice: '期望价格',
      expectedPricePlaceholder: '请输入期望价格，如：USD 2500',
      note: '磋商说明',
      notePlaceholder: '请输入磋商说明，如期望调整的项目、原因等',
      messages: {
        expectedPriceRequired: '请输入期望价格',
        quotationIdMissing: '报价ID不存在',
        submitSuccess: '磋商提交成功',
        submitFailed: '提交磋商失败'
      }
    }
  },

  // ======== Shokz AI询价识别 行内面板 ========
  shokzAiInquiryRecognition: {
    title: 'AI 识别回填',
    upload: {
      title: '点击或拖拽上传询价文件',
      supportedFormats: '支持 JPG/PNG/PDF/Excel/Word 格式'
    },
    warning: '如果是仅询港前/尾程费用，请在提供的信息前分别清晰备注"港前"、"尾程"字样。',
    textPlaceholder: `请粘贴需要识别的文本内容，例如：
整箱/拼箱：From CNSHA/Shanghai to USLAX/Los Angeles
Carrier: Maersk
Container: 2x20GP + 1x40HC
Weight: 1200 KGS
CBM: 6.5
Service terms: DDP
货物类型：普货
HS Code: 85183000

空运：From PVG/上海浦东机场 to LAX/洛杉矶机场
Flight No: CA123
Pieces: 20 CTNS
Weight: 320 KGS
CBM: 1.8

港前：港前 装货地：中国上海市浦东新区祖冲之路887号，起运港：CNSHA 上海港

尾程：尾程 卸货港：NLRTM 鹿特丹港，配送类型：第三方地址，美国加州洛杉矶 1000 W 190th St

滚装/散杂：滚装 车辆类型SUV 数量2；或散杂货 件数10 毛重5000KGS 体积20CBM`,
    startButton: '开始识别',
    messages: {
      emptyInput: '请上传文件或输入文本内容',
      error: 'AI识别失败，请重试',
      filledCount: 'AI识别完成，本次共填入 {filled} 个字段',
      noResult: '未识别到有效信息，请检查输入内容'
    }
  },

  // ======== Shokz 报价汇总 ========
  shokzQuoteCompare: {
    pageTitle: '报价汇总',
    quoteCount: '报价数量',
    quotationList: '报价列表',
    sortedByAmount: '按总金额升序排列',
    confirmTitle: '确认入库',
    confirmWarning: '确认后，该报价将写入运价库，询价状态将变更为"已确认"，是否继续？',
    supplier: '供应商',
    totalAmount: '总金额',
    loadFailed: '加载报价汇总数据失败',
    onlyQuotedCanConfirm: '仅已报价状态可以确认入库',
    confirmSuccess: '确认入库成功',
    confirmFailed: '确认入库失败',
    columns: {
      supplier: '供应商',
      contact: '联系人',
      carrier: '船公司',
      directTransit: '直达/中转',
      transitDays: '航程(天)',
      baseFreight: '基础运费',
      extraFees: '附加费',
      totalAmount: '总金额',
      validUntil: '有效期至',
      status: '状态',
      action: '操作'
    },
    basicInfo: {
      inquiryNo: '询价编号',
      inquiryNature: '询价性质',
      loadingPort: '起运港',
      dischargePort: '卸货港',
      carrier: '船公司',
      cargoReadyTime: '货好时间',
      containerTypes: '箱型'
    },
    actions: {
      confirm: '确认入库'
    }
  },

  // ======== Shokz 地址分配弹窗 ========
  shokzAddressAllocModal: {
    title: '地址分配',
    description: '以下地址无法自动识别，请手动分配到对应的字段：',
    unknownAddress: '待识别地址',
    selectPlaceholder: '请选择',
    options: {
      stuffing: '港前装箱门点',
      delivery: '尾程送货地址'
    },
    cancel: '取消',
    confirm: '确认回显'
  }
}
